import { getCookie } from "./helper-function";
 
export function getReferrer(): string {
  const PROJECT_DOMAINS: Record<string, Record<string, string>> = {
    Whatuni: {
      dev: "https://mdev.dev.aws.whatuni.com",
      stg: "https://mtest.test.aws.whatuni.com",
      prd: "https://www.whatuni.com",
    },
    PGS: {
      dev: "https://mdev.dev.aws.postgraduatesearch.com",
      stg: "https://mtest.test.aws.postgraduatesearch.com",
      prd: "https://www.postgraduatesearch.com",
    },
  };
  const project = process.env.PROJECT || "Whatuni";
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT || "dev";
  const DOMAINS = PROJECT_DOMAINS[project] || PROJECT_DOMAINS.whatuni;
  const cookie = getCookie("urlHistory");
  if (!cookie) return document.referrer;
 
  try {
    const previous = JSON.parse(decodeURIComponent(cookie || "{}"))?.previous;
    return (typeof previous === "string" && previous)
      ? `${DOMAINS[environment] || "http://localhost:3000"}${previous}`
      : document.referrer;
  } catch {
    return document.referrer;
  }
}
 
 